module.exports = __webpack_public_path__ + "2e19670be60029ac11203a77f9d80f42.pdf";